import React from "react";
import { Alert, Box, Grid, Stack, Typography } from "@mui/material";
import { useMutation } from "react-query";
import LoginForm from "./partials/LoginForm";
import { useAlert } from "../../../contexts/alertContext";
import { signIn } from "../../../framework/auth";
import { ILoginResponse } from "../../../types/auth";
import { LocalStorage } from "../../../enums/localStorage";
import MuiSnackbar from "../../../components/UI/MuiSnackbar/MuiSnackbar";
import useApp from "hooks/useApp";
import ILogo from "assets/images/logo.jpg";
const Login: React.FC = () => {

  const [inputObj, setInputObj] = React.useState<{
    Username: string;
    Password: string;
  }>({
    Username: "",
    Password: "",
  });
  const [errMessage, setErrMessage] = React.useState<string>("");
  const { alert } = useAlert();
const {push}=useApp()
  const mutationLogin = useMutation({
    mutationFn: (createInput: any) => {
      return signIn({ data: createInput });
    },
  });



  const handleChange = (name: string, value: any) => {
    setInputObj({ ...inputObj, [name]: value });
  };
  const onSubmit = async (data: any) => {
  
      try {
        const response: ILoginResponse = await mutationLogin.mutateAsync(
          inputObj
        );
        if (!response?.accessToken) {
          setErrMessage("Invalid Credentials");
          return;
        }
        localStorage.setItem(LocalStorage.ACCESS_TOKEN, response.accessToken);
        localStorage.setItem(LocalStorage.REFRESH_TOKEN, response.refreshToken);
        push('/plans')
 
      } catch (err: any) {
        setErrMessage("Invalid Credentials");
      }
    }
  

  return (
    <>
      <Box
        component="main"
        sx={{
          display: "flex",
          flex: "1 1 auto",
          minHeight: "100vh",
        }}
      >
        <Grid container sx={{ flex: "1 1 auto" }}>
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              backgroundColor: "#FFFFFF",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <Box
              component="header"
              sx={{
                backgroundColor: "background.default",
                alignItems: "center",
                padding: 3,
                px: 5,
              }}
            >
              <Typography variant="h4">Welcome to Service Portal</Typography>
              {/* <Typography
                align="center"
                color="inherit"
                sx={{
                  fontSize: "24px",
                  lineHeight: "32px",
                  mb: 1,
                }}
                variant="h2"
              >
                Welcome to{" "}
                <Box component="a" sx={{ color: "#15B79E" }} target="_blank">
                  NEXTLMS
                </Box>
              </Typography> */}
              {/* <Typography align="center" sx={{ mb: 3 }} variant="subtitle1">
                Use your credentials to access your account.
              </Typography> */}
            </Box>
            <Grid
              container
              sx={{
                backgroundColor: "#FFFFFF",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  maxWidth: 550,
                  p: 3,
                  width: "100%",
                }}
              >
                <Stack spacing={1} sx={{ mb: 3 }}>
                  <Typography variant="h4">Login</Typography>
                </Stack>
                <Stack spacing={2} width={"100%"}>
                  <LoginForm
                    onChange={handleChange}
                    onSubmit={onSubmit}
                  />
                  {errMessage && (
                    <Alert severity={"error"} variant={"outlined"}>
                      {errMessage}
                    </Alert>
                  )}
                </Stack>
              </Box>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              alignItems: "center",
              background:
                "radial-gradient(50% 50% at 50% 50%, #122647 0%, #090E23 100%)",
              color: "white",
              display: "flex",
              justifyContent: "center",
              "& img": {
                maxWidth: "100%",
              },
            }}
          >
            <Box sx={{ p: 3 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingBlock: "10px",
                  minWidth:'200px'
                }}
              >
               
                <Typography variant="h1" >
                  <span style={{paddingInline:4,color:'#c1c167'}}>IT</span>SOLUTIONLB
                </Typography>
              </div>
            </Box>
          </Grid>
        </Grid>
      
      </Box>
      <MuiSnackbar alert={alert!} />
    </>
  );
};

export default Login;
